module.exports = __webpack_public_path__ + "img/symbol_9.74a7e45d.png";